import { render, staticRenderFns } from "./AforoArchivos.vue?vue&type=template&id=384f31ce"
import script from "./AforoArchivos.vue?vue&type=script&lang=js"
export * from "./AforoArchivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports